import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const adminAxios = axios.create({
  baseURL: `${BACKEND_URL}/api/admin`,
  withCredentials: true,
});

// Add auth token to requests
adminAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const adminApi = {
  // Dashboard
  getDashboard: () => adminAxios.get('/dashboard'),
  
  // Users
  getUsers: (params) => adminAxios.get('/users', { params }),
  getUser: (userId) => adminAxios.get(`/users/${userId}`),
  banUser: (userId, data) => adminAxios.post(`/users/${userId}/ban`, data),
  unbanUser: (userId) => adminAxios.post(`/users/${userId}/unban`),
  deleteUser: (userId) => adminAxios.delete(`/users/${userId}`),
  
  // Leagues
  getLeagues: (params) => adminAxios.get('/leagues', { params }),
  updateLeagueStatus: (leagueId, status) => adminAxios.post(`/leagues/${leagueId}/status`, { status }),
  deleteLeague: (leagueId) => adminAxios.delete(`/leagues/${leagueId}`),
  
  // Tournaments
  getTournaments: (params) => adminAxios.get('/tournaments', { params }),
  deleteTournament: (tournamentId) => adminAxios.delete(`/tournaments/${tournamentId}`),
  
  // Games
  getGames: () => adminAxios.get('/games'),
  toggleGame: (gameId, enabled) => adminAxios.post(`/games/${gameId}/toggle`, { enabled }),
  
  // Consents
  getConsents: (params) => adminAxios.get('/consents', { params }),
  
  // Logs
  getLogs: (params) => adminAxios.get('/logs', { params }),
  
  // Settings
  getSettings: () => adminAxios.get('/settings'),
  updateSettings: (data) => adminAxios.post('/settings', data),
  
  // Announcements
  getAnnouncements: () => adminAxios.get('/announcements'),
  createAnnouncement: (data) => adminAxios.post('/announcements', data),
  deleteAnnouncement: (id) => adminAxios.delete(`/announcements/${id}`),
  
  // System Status
  getSystemStatus: () => adminAxios.get('/system-status'),
  
  // Analytics
  getAnalytics: (period) => adminAxios.get('/analytics', { params: { period } }),
};

export default adminApi;
